"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapPaymentTypeToProvider = void 0;
const homi_shared_1 = require("@getgreenline/homi-shared");
const enums_1 = require("../models/blazepay/enums");
const mapPaymentTypeToProvider = (paymentTypeId) => {
    const mapping = {
        [homi_shared_1.PaymentTypeIds.blazepay]: enums_1.PaymentServiceProviderId.blazepay,
        [homi_shared_1.PaymentTypeIds.birchmount]: enums_1.PaymentServiceProviderId.birchmount,
    };
    return mapping[paymentTypeId];
};
exports.mapPaymentTypeToProvider = mapPaymentTypeToProvider;
//# sourceMappingURL=BlazepayHelpers.js.map